import { createLogic } from "redux-logic";
import type { EcoConsumptionLogicType } from "../reducers/EcoConsumptionReducer";
import {
    resetEcoConsumptionCosts,
    setEcoConsumptionCosts,
    setEcoConsumptionConfiguration,
} from "../reducers/EcoConsumptionReducer";
import { findConfigurationByEngineType, formatEcoConsumptionConfiguration } from "../../utils/formatEcoConsumption";

const setEcoConsumptionCostsLogic = (
    createLogic as EcoConsumptionLogicType<ReturnType<typeof setEcoConsumptionCosts | typeof resetEcoConsumptionCosts>>
)({
    type: [setEcoConsumptionCosts.type, resetEcoConsumptionCosts.type],
    latest: true,
    async process({ action, getState }, dispatch, done) {
        const { ecoConsumption, commonSettings, specs, car } = getState();
        if (action.payload && typeof action.payload !== "string") {
            const { costs } = action.payload;
            // Generate the full configuration
            if (ecoConsumption.ace) {
                const configuration = formatEcoConsumptionConfiguration(
                    commonSettings,
                    findConfigurationByEngineType(ecoConsumption.ace, car.motorization.engine),
                    specs.techSpecs,
                    costs,
                );
                if (configuration) {
                    dispatch(
                        setEcoConsumptionConfiguration({
                            configuration,
                        }),
                    );
                }
            }
        }

        done();
    },
});

const ecoConsumptionLogic = [setEcoConsumptionCostsLogic];

export default ecoConsumptionLogic;
